export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-enabled-960-713b4591177292e99a0e6ec8e3cdd53f.png";